<form [formGroup]="form">
  <div class="d-flex flex-row">
    <div class="booking-save-time-slots mr-2" *ngFor="let timeSlot of timeSlots">
      <label>
        <input type="radio" [value]="timeSlot.courtTimeSlotId" formControlName="timeSlot">
        <span class="ml-1">{{timeSlot.name}}</span>
      </label>
    </div>
  </div>
</form>
